import React from 'react';
import { MdClose } from 'react-icons/md';
import './manually-add-student-popup.css';
import { InputWithInsetLabel } from '../../DanitComponents/Inputs/InputWithInsetLabel';
import axios from 'axios';
import { baseUrl } from '../../assets/Animations';
import { getRequestHeaders } from '../../api';

const ManuallyAddStudentPopup = ({manuallyAddStudentPopup, setManuallyAddStudentPopup, createASpecificCardForASpecificFamily}) => {
    const [familySuggestions, setFamilySuggestions] = React.useState([])

    const getFamilySuggestions = (query) => {
        console.log(query)
        axios.get(`${baseUrl}/search/${query}`, getRequestHeaders())
        .then(res => {
            console.log(res.data)
            setFamilySuggestions(res.data)
        })
        .catch(err => {
            console.log(err)
        })
    }

    const selectTheFamily = (id) => {
        createASpecificCardForASpecificFamily(id, manuallyAddStudentPopup[1], manuallyAddStudentPopup[0],setManuallyAddStudentPopup)
    }

        return (
            <div className='manually-add-student-popup__wrapper' id='manually-add-student-popup__wrapper' onClick={(e) => e.target.id === 'manually-add-student-popup__wrapper' && setManuallyAddStudentPopup(false)}>
                <div className='manually-add-student-popup'>
                    <div className='manually-add-student-popup__top-section'>
                        <div className='manually-add-student-popup__title'>Add a {manuallyAddStudentPopup[0]} {manuallyAddStudentPopup[1]} card</div>
                        <MdClose cursor={'pointer'} size={24} color='#94A3B8' onClick={() => setManuallyAddStudentPopup(false)} />
                    </div>
                    <div className='manually-add-student-popup__search-section'>
                        <InputWithInsetLabel label='Connect to a family' placeholder='Find a family profile' changeFunction={(e) => getFamilySuggestions(e.target.value)} />
                        <div className='manually-add-student-popup__search-section__results-wrapper'>
                            {familySuggestions.map((family, index) => (
                                <div className='manually-add-student-popup__search-section__result' key={index} onClick={() => {selectTheFamily(family.familyId)}}>{family.primaryParentName} {family.familyName} ({family.school})</div>
                            ))}
                        </div>
                    </div>
                    <div className='manually-add-student-popup__btn-wrapper'>
                        <div className='manually-add-student-popup__btn'>Go Back</div>
                        <div className='manually-add-student-popup__btn-primary'>Add Card</div>
                    </div>
                </div>
            </div>
        );
}

export default ManuallyAddStudentPopup;
